import type { components } from '@/types/apiSchema';

export const candidateTabs = [
  'summary',
  'prescreen',
  'experience',
  'activity',
] as const;

export type CandidateTab = (typeof candidateTabs)[number];

export type CandidateDecision =
  | 'awaiting'
  | 'approved'
  | 'interviewing'
  | 'rejected'
  | 'declined'
  | 'hired';

export type PendingDecisionAction = 'reject' | null;

export type CandidateFinding =
  components['schemas']['HiringManagerAssessmentFindingResponse'];

export interface CandidateDetailData {
  candidateId: string;
  name: string;
  firstName: string;
  matchedRole: string;
  currentRole: string;
  location: string | null;
  totalExperience: string | null;
  linkedInUrl: string | null;
  assessment: {
    mode: components['schemas']['AssessmentMode'];
    summary: string | null;
    strengths: CandidateFinding[];
    prescreenSummary: string | null;
    confirmedFacts: CandidateFinding[];
    openQuestions: CandidateFinding[];
    concerns: CandidateFinding[];
    ledgerStage: components['schemas']['AssessmentLedgerStage'] | null;
    ledger: components['schemas']['CandidateLedgerAudienceResponse'] | null;
    sourcedLedger:
      | components['schemas']['CandidateLedgerAudienceResponse']
      | null;
    scoredLedger:
      | components['schemas']['CandidateLedgerAudienceResponse']
      | null;
    atSubmissionLedgerStage:
      | components['schemas']['AssessmentLedgerStage']
      | null;
    atSubmissionLedger:
      | components['schemas']['CandidateLedgerAudienceResponse']
      | null;
  } | null;
  prescreen:
    | components['schemas']['HiringManagerPrescreenContextResponse']
    | null;
  candidateJobId: string;
  /** Self-service jobs let the hiring manager approve a submitted candidate. */
  isSelfServiceJob: boolean;
  screeningMethod: components['schemas']['ScreeningMethod'];
  /** The pre-screen link already sent in outreach, if any. */
  sharedPrescreenLinkType:
    | components['schemas']['CandidateJobPrescreeningType']
    | null;
  /** The hiring manager's own call notes, exactly as typed. */
  prescreenNote:
    | components['schemas']['HiringManagerPrescreenNoteResponse']
    | null;
}

/** Position of this candidate in the job's "needs your decision" queue. */
export interface CandidateQueuePosition {
  index: number;
  total: number;
  previous?: { candidateId: string; name: string };
  next?: { candidateId: string; name: string };
}
